import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmDeleteCartOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ConfirmDeleteCartOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">Confirm Delete</h2>
                    <p><b>You are about to delete your cart.</b></p>
                    <p>All products will be deleted from the cart and saved order data will be cleared.</p>
                    <p>Do you want to continue?</p>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    <a className="blueButton yesButton" onClick={this.props.deleteCart}>Continue</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

ConfirmDeleteCartOverlayDialog = connect(mapStateToProps)(ConfirmDeleteCartOverlayDialog);
export default ConfirmDeleteCartOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmDeleteCartOverlayDialog.js